export function resolveNativeReady() {
  this.ready.resolve();
}
